export const upcomingSurvey = "upcoming";
export const endedSurvey = "ended";
export const inProgressSurvey = "in progress";
export const completedSurvey = "completed";
export const overdueSurvey = "overdue";
export const surveyStatusesConfig = [inProgressSurvey, endedSurvey, upcomingSurvey, completedSurvey, overdueSurvey];
export const textEllipsesStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};

export const surveyStatusesValues = {
    upcoming: upcomingSurvey,
    ended: endedSurvey,
    in_progress: inProgressSurvey,
    completed: completedSurvey,
    overdue: overdueSurvey,
};

export const surveysModuleInfo = {
    name: 'Surveys',
    pricingId: 'surveys',
};